import PropTypes from 'prop-types';
export default {
  sx: PropTypes.object,
  className: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  node: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};